export default "__VITE_ASSET__C6vLmZ5n__"